import { ToolNames } from '@/shared/config';

export const PANO_TOOLS: ToolNames[] = [
  'expand',
  'split',
  'sharpness',
  'brightness',
  'invert',
  'reset',
  'editNumbers',
];

export const PANO_DEFAULT_HEIGHT = 300;
export const SKELETON_DEFAULT_HEIGHT = 150;
